import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/portfolio-section.tsx");
